







import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import { CheckoutInit } from '../../mixins/checkout-init'
import { paypalCaptureOrder } from '../../api-marketplace/payments'

@Component
export default class FinishPayPalPage extends Mixins(CheckoutInit) {
    callErrors = ''

    get approvedPayPalOrderId(): string {
        return this.$route.query.token.toString()
    }

    async initSession() {
        try {
            await paypalCaptureOrder(this.orderId, this.approvedPayPalOrderId)
            this.onSuccess()
        } catch (error) {
            this.onError()
        }
    }
}
